import { formatDollars } from '@fruitful/fruitils';
import React from 'react';
import {
    BodyLargeRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    XStack,
    YStack,
} from 'smoothie';

interface RetirementCalculatorHeaderProps {
    selectedAmount: number;
    onEditInputs: () => void;
    onRecalculate: () => void;
    onViewAllSimulations: () => void;
    onEditSelectedAmount: () => void;
}

export const RetirementCalculatorHeader = ({
    selectedAmount,
    onEditInputs,
    onRecalculate,
    onViewAllSimulations,
    onEditSelectedAmount,
}: RetirementCalculatorHeaderProps) => {
    return (
        <XStack
            gap={24}
            width="100%"
            padding={16}
            alignItems="center"
            justifyContent="space-between"
        >
            {/* Left side - Edit Inputs and Re-calculate Buttons */}
            <XStack gap={12}>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.SMALL}
                    text="Edit Inputs"
                    onPress={onEditInputs}
                    width="auto"
                />
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.SMALL}
                    text="Re-calculate"
                    onPress={onRecalculate}
                    width="auto"
                />
            </XStack>

            {/* Right side - Current Selected Amount and Action Buttons */}
            <XStack gap={16} alignItems="center">
                {/* Current Selected Total Contribution Display */}
                <YStack gap={4} alignItems="flex-end">
                    <BodyLargeRegular color="$gray1000">
                        Current Selected Contribution Amount
                    </BodyLargeRegular>
                    <BodyLargeRegular fontWeight="emphasized">
                        {formatDollars(selectedAmount)}
                    </BodyLargeRegular>
                </YStack>

                {/* View All Simulations Button */}
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.SMALL}
                    text="View All Simulations"
                    onPress={onViewAllSimulations}
                    width="auto"
                />

                {/* Edit Selected Amount Button */}
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.SMALL}
                    text="Edit Contribution Amount"
                    onPress={onEditSelectedAmount}
                    width="auto"
                />
            </XStack>
        </XStack>
    );
};
